import React from 'react';
import { Controller } from 'react-hook-form';
import styled from '@emotion/styled';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { RegularText } from '@/components/text';
import { RequiredMark } from '@/components/input/InputBasic';
import { mq } from '@/utils/mediaQuery';

const Container = styled(RadioGroup)(() => ({
  minHeight: '10rem',
}));

const StyledRadioGroup = styled(RadioGroup)(() => ({
  display: 'flex',
  flexDirection: 'row',
  border: '1px solid rgba(0, 0, 0, 0.2)',
  borderRadius: '0.8rem',
  marginTop: '0.2rem',
  padding: '0.6rem 1.4rem',

  '& > label': {
    flex: 1,
    '& > span': { fontSize: '1rem' },

    [mq('tablet')]: {
      '& > span': { fontSize: '1.6rem' },
    },
  },
}));
const RadioInput = (props) => {
  return (
    <Container>
      <Controller
        control={props.control}
        name={props.name}
        render={({ field }) => {
          return (
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">
                <>
                  <RegularText id={props.label} fontSize="1.6rem" />

                  {props.required && <RequiredMark>*</RequiredMark>}
                </>
              </FormLabel>

              <StyledRadioGroup
                defaultValue="female"
                name="radio-buttons-group"
                {...field}
                {...props}
              >
                {props.arr?.map((option) => {
                  return (
                    <FormControlLabel
                      value={option.code_value}
                      control={<Radio />}
                      label={option.name}
                      key={option.code_value}
                    />
                  );
                })}
              </StyledRadioGroup>
            </FormControl>
          );
        }}
      />
    </Container>
  );
};

export default RadioInput;
